import React from "react"

import { EmailSuccessWrapper } from "../styled"

const EmailSuccess = ({text, footer}) => {

  return (
    <EmailSuccessWrapper className={footer? 'isFooter' : 'isSidebar'}>
      <p>
        {text}
      </p>
    </EmailSuccessWrapper>
  )
}

export default EmailSuccess